"use client";
import * as r from "react";
import { c as f } from "./useRenderElement-B8V3_e8R.mjs";
import { u as p } from "./CompositeRootContext-Eb_XU-qm.mjs";
import { u as h } from "./useCompositeListItem-Dxy1vBYe.mjs";
function I(m = {}) {
  const {
    highlightItemOnHover: s,
    highlightedIndex: u,
    onHighlightedIndexChange: i
  } = p(), {
    ref: c,
    index: e
  } = h(m), t = u === e, n = r.useRef(null), a = f(c, n);
  return {
    compositeProps: r.useMemo(() => ({
      tabIndex: t ? 0 : -1,
      onFocus() {
        i(e);
      },
      onMouseMove() {
        const o = n.current;
        if (!s || !o)
          return;
        const d = o.hasAttribute("disabled") || o.ariaDisabled === "true";
        !t && !d && o.focus();
      }
    }), [t, i, e, s]),
    compositeRef: a,
    index: e
  };
}
export {
  I as u
};
